var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tienda",attrs:{"id":"tienda"}},[_c('v-toolbar',{staticClass:"sub-toolbar",attrs:{"flat":""}},[_c('Menu')],1),_c('ProductsList',{attrs:{"tienda":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }